import React, { useState, useEffect } from 'react';
import { DownloadSimple, X } from '@phosphor-icons/react';

export default function InstallPWA() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      // Show banner if not already installed and not dismissed
      const dismissed = localStorage.getItem('pwa_dismissed');
      if (!dismissed) setShowBanner(true);
    };
    window.addEventListener('beforeinstallprompt', handler);

    // Check if already installed
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setShowBanner(false);
    }

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      setShowBanner(false);
    }
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem('pwa_dismissed', 'true');
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] bg-[#0A0A0A] text-white p-4 flex items-center gap-3 shadow-lg border-t border-[#002FA7]" data-testid="pwa-install-banner">
      <img src="/carloo-icon-192.png" alt="Carloo" className="w-12 h-12 rounded-lg" />
      <div className="flex-1">
        <p className="text-sm font-bold">Install Carloo App</p>
        <p className="text-xs text-white/50">Add to home screen for quick access</p>
      </div>
      <button
        onClick={handleInstall}
        className="px-4 py-2 bg-[#002FA7] text-white text-xs font-bold uppercase tracking-widest hover:bg-[#002FA7]/90"
        data-testid="pwa-install-btn"
      >
        <DownloadSimple size={16} className="inline mr-1" /> Install
      </button>
      <button onClick={handleDismiss} className="p-1 text-white/40 hover:text-white">
        <X size={18} />
      </button>
    </div>
  );
}
